import Switch from "../../Switch";
import Typography from "../../Typography";

export default function SwitchItem({botaoDeslizar, texto, otimizado, onChange, checked}) {
    return (
        <Switch onChange={onChange} checked={checked} botaoDeslizar={botaoDeslizar}>
            <div className={`justify-start items-center gap-1 flex ${botaoDeslizar && "ml-2"}`}>
                <div className="w-3 h-3 relative ">
                    <div className={`w-3 h-3 left-0 top-0 absolute bg-${otimizado ? "sucess-main" : "error-main"} rounded-full`} />
                </div>
                <Typography className="ml-1">{texto}</Typography>
            </div>
        </Switch>
    )
}